/**
 * Job Activities Service
 * Handles API calls for job activity tracking
 */

import { apiClient } from './api';
import type { JobActivityDto, LogJobActivityRequest } from '../application/service-provider/types/activity';

export const jobActivitiesService = {
  /**
   * Get all activities for a job
   * @param jobId - The job ID
   * @param types - Optional array of activity types to filter by
   * @returns Array of job activities
   */
  async getJobActivities(jobId: string, types?: string[]): Promise<JobActivityDto[]> {
    const queryParams = new URLSearchParams();
    if (types && types.length > 0) {
      types.forEach(type => queryParams.append('types[]', type));
    }

    const url = `/provider/jobs/${jobId}/activities${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await apiClient.get<{ activities: JobActivityDto[] }>(url);
    return response.activities;
  },

  /**
   * Log a new activity for a job
   * @param jobId - The job ID
   * @param request - Activity details to log
   * @returns The created activity
   */
  async logActivity(jobId: string, request: LogJobActivityRequest): Promise<JobActivityDto> {
    const response = await apiClient.post<{ activity: JobActivityDto }>(
      `/provider/jobs/${jobId}/activities`,
      request
    );
    return response.activity;
  },
};
